import { trackAnalyticsEvent } from '@cof/refi-web-sdk';
import { environment } from '../../../environment/environment.js';

const ENV_PATH = environment.isStaticCloud() ? '/_origin/dxgw/_call' : '';

export const REFI_VEHICLE_LOAN_CONST = {
  TRACK_EVENT: trackAnalyticsEvent,
  TIMEOUTS: {
    TWO_MINUTES: 120000,
    FIVE_SEC: 5000,
  },
  IDP_DXGW_LOGOUT_URL() {
    const isProdEnv = window.location.hostname === 'autorefi.capitalone.com';
    return isProdEnv
      ? REFI_VEHICLE_LOAN_CONST.BASE_LOGOUT_DXGW_PROD_URL
      : REFI_VEHICLE_LOAN_CONST.BASE_LOGOUT_DXGW_QA_URL;
  },
  isSBEnv() {
    return [
      'refi-web-ui-sb.clouddqt.capitalone.com',
      'fs-vehicle-and-loan-mfe-sb.clouddqtext.capitalone.com',
      'auto-refi-sb.clouddqt.capitalone.com',
    ].includes(window.location.hostname);
  },
  isDevEnv() {
    return [
      'refi-web-ui-dev.clouddqt.capitalone.com',
      'fs-vehicle-and-loan-mfe-dev.clouddqtext.capitalone.com',
      'auto-refi-dev.clouddqt.capitalone.com',
    ].includes(window.location.hostname);
  },
  isQAEnv() {
    return [
      'coaf-refi-web-ui-qa.capitalone.com',
      'fs-vehicle-and-loan-mfe-qa.capitalone.com',
      'autorefi-ext-preprod.capitalone.com',
      'auto-refi-qa.clouddqt.capitalone.com',
    ].includes(window.location.hostname);
  },
  isProdEnv() {
    return [
      'coaf-refi-web-ui.capitalone.com',
      'fs-vehicle-and-loan-mfe.capitalone.com',
      'autorefi.capitalone.com',
    ].includes(window.location.hostname);
  },
  REFI_WEB_UI_URL: () => {
    switch (window.location.hostname) {
      case 'autorefi.capitalone.com':
        return 'https://coaf-refi-web-ui.capitalone.com';
      case 'autorefi-ext-preprod.capitalone.com':
      case 'auto-refi-qa.clouddqt.capitalone.com':
      case 'auto-refi-dev.clouddqt.capitalone.com':
      case 'auto-refi-sb.clouddqt.capitalone.com':
        return 'https://coaf-refi-web-ui-qa.capitalone.com';
      default:
        return 'http://localhost:4300';
    }
  },
  VEHICLE_AND_LOAN_BFF_BASE_PATH: `${ENV_PATH}/protected/1025035/fs-vehicle-and-loan-bff/`,
  GET_FEATURE_TOGGLE_URL: (featureKey) =>
    `${ENV_PATH}/protected/1025035/fs-vehicle-and-loan-bff/features/${featureKey}`,
  FEATURE_TOGGLES: {
    ICONIC_VL_FEATURE_TOGGLE: 'iconic-invisible-pq',
  },
  SAVE_VEHICLE_AND_LOAN_INFO_URL() {
    return `${REFI_VEHICLE_LOAN_CONST.VEHICLE_AND_LOAN_BFF_BASE_PATH}lead/save-vehicle-and-loan-info`;
  },
  STIP_TYPE: {
    TITLE: 'Title',
  },
  STIP_INCOMPLETE: 'INCOMPLETE',
  GET_VEHICLE_INFORMATION_URL: (eAppId) =>
    `${REFI_VEHICLE_LOAN_CONST.VEHICLE_AND_LOAN_BFF_BASE_PATH}applications/${eAppId}/vehicle`,
  GET_APPLICATION_TASKS_URL: (eAppId) =>
    `${REFI_VEHICLE_LOAN_CONST.VEHICLE_AND_LOAN_BFF_BASE_PATH}applications/${eAppId}/application-tasks`,
  GET_POLICY_LIMITS_URL: () =>
    `${REFI_VEHICLE_LOAN_CONST.VEHICLE_AND_LOAN_BFF_BASE_PATH}credit-policy-limits`,
  VEHICLE_LOOKUP_TYPE: {
    LICENSE_PLATE: 'licensePlateSearch',
    VIN: 'vinSearch',
    SSN: 'ssnSearch',
  },
  MARKETING_ATTRIBUTE_COOKIE: 'afw3',
  TIMEOUT_IN_MS: 10000,
  US_STATES: [
    { value: 'AL', name: 'Alabama' },
    { value: 'AK', name: 'Alaska' },
    { value: 'AR', name: 'Arkansas' },
    { value: 'AZ', name: 'Arizona' },
    { value: 'AE', name: 'Armed Forces' },
    { value: 'AA', name: 'Armed Forces Americas' },
    { value: 'AP', name: 'Armed Forces Pacific' },
    { value: 'CA', name: 'California' },
    { value: 'CO', name: 'Colorado' },
    { value: 'CT', name: 'Connecticut' },
    { value: 'DE', name: 'Delaware' },
    { value: 'DC', name: 'District Of Columbia' },
    { value: 'FL', name: 'Florida' },
    { value: 'GA', name: 'Georgia' },
    { value: 'HI', name: 'Hawaii' },
    { value: 'ID', name: 'Idaho' },
    { value: 'IL', name: 'Illinois' },
    { value: 'IN', name: 'Indiana' },
    { value: 'IA', name: 'Iowa' },
    { value: 'KS', name: 'Kansas' },
    { value: 'KY', name: 'Kentucky' },
    { value: 'LA', name: 'Louisiana' },
    { value: 'ME', name: 'Maine' },
    { value: 'MD', name: 'Maryland' },
    { value: 'MA', name: 'Massachusetts' },
    { value: 'MI', name: 'Michigan' },
    { value: 'MN', name: 'Minnesota' },
    { value: 'MS', name: 'Mississippi' },
    { value: 'MO', name: 'Missouri' },
    { value: 'MT', name: 'Montana' },
    { value: 'NE', name: 'Nebraska' },
    { value: 'NV', name: 'Nevada' },
    { value: 'NH', name: 'New Hampshire' },
    { value: 'NJ', name: 'New Jersey' },
    { value: 'NM', name: 'New Mexico' },
    { value: 'NY', name: 'New York' },
    { value: 'NC', name: 'North Carolina' },
    { value: 'ND', name: 'North Dakota' },
    { value: 'OH', name: 'Ohio' },
    { value: 'OK', name: 'Oklahoma' },
    { value: 'OR', name: 'Oregon' },
    { value: 'PA', name: 'Pennsylvania' },
    { value: 'RI', name: 'Rhode Island' },
    { value: 'SC', name: 'South Carolina' },
    { value: 'SD', name: 'South Dakota' },
    { value: 'TN', name: 'Tennessee' },
    { value: 'TX', name: 'Texas' },
    { value: 'UT', name: 'Utah' },
    { value: 'VT', name: 'Vermont' },
    { value: 'VA', name: 'Virginia' },
    { value: 'WA', name: 'Washington' },
    { value: 'WV', name: 'West Virginia' },
    { value: 'WI', name: 'Wisconsin' },
    { value: 'WY', name: 'Wyoming' },
  ],
  VIN_VALIDATION_ERRORS: {
    INVALID_VIN: {
      KEY: 'invalidVin',
      MESSAGE:
        'The letters I, O and Q never appear in a modern VIN. Try using the number 1 or 0 instead.',
    },
    CHECK_DIGIT_FAIL: {
      KEY: 'posInvalidVin',
      MESSAGE: 'Please enter a valid VIN',
    },
    MIN_LENGTH: {
      KEY: 'vinMinLength',
      MESSAGE: 'Please enter a 17 character VIN',
    },
  },
  PROMO_STORAGE_KEY: 'auto-refi-offerkey',
  PROMOTION_TYPES: {
    GUARANTEED_RATE: 'GUARANTEED_RATE',
    PRE_APPROVAL: 'PRE_APPROVAL',
  },
  OFFER_TYPE_CODES: {
    guaranteedRate: 'GUARANTEED_RATE',
    preApproval: 'PRE_APPROVAL',
  },
  PRODUCT_TYPE_CODES: {
    GUARANTEED_RATE: 'GUARANTEED_RATE',
    PRE_APPROVED: 'PRE_APPROVED',
    BAU: 'BAU',
  },
  VIN_HELPER_TEXT:
    'Find your VIN on your insurance card or your windshield where it meets the dashboard on the driver’s side.',
  ICONIC_VIN_HELPER_TEXT:
    'Find your VIN on your insurance card or on the driver’s side windshield where it meets the dashboard.',
  /*
  REMAINING_TERM_HELPER_TEXT() {
    return `Your remaining term must be at least ${REFI_VEHICLE_LOAN_CONST.MIN_REMAINING_TERM} months.`;
  },
*/
  SESSION_KEY: {
    REFI_SESSION_KEY: 'auto-refi-session',
    PI_KEY: 'auto-refi-pi',
    PROMO_CODE_KEY: 'auto-refi-promocode',
    PREQUAL_INFO_KEY: 'auto-refi-prequal',
    VEHICLE_CONSENT_KEY: 'auto-refi-consent',
    USED_MANUAL_LOAN_KEY: 'auto-refi-used-manual-loan',
    MANUAL_LOAN_KEY: 'auto-refi-manual-loan',
    SELECTED_LOAN_KEY: 'auto-refi-selected-loan',
    UPFRONT_OFFERS_KEY: 'auto-refi-upfront-offers',
    LICENSE_PLATE_STATE_CODE_KEY: 'auto-refi-license-plate-state-code',
  },
  REFI_CI_KEY: 'refi-ci',
  HTTP_HEADERS: {
    Accept: 'application/json;v=1',
    'Content-Type': 'application/json;v=1',
  },
  BFF_SEARCH_ENDPOINT_MAP: {
    vinSearch: 'vehicles/search-by-vin',
    licensePlateSearch: 'vehicles/search-by-licenseplate',
    vehicleAndLoanSearch: 'search-vehicle-and-loan',
  },
  SSN_VEHICLE_LOOKUP_STATES: [
    'AA',
    'AE',
    'AL',
    'AP',
    'AZ',
    'CO',
    'CT',
    'DE',
    'FL',
    'GA',
    'IL',
    'IA',
    'ID',
    'KS',
    'KY',
    'LA',
    'MA',
    'ME',
    'MD',
    'MI',
    'MN',
    'MS',
    'MO',
    'MT',
    'NC',
    'ND',
    'NE',
    'NJ',
    'NY',
    'NM',
    'OK',
    'OH',
    'RI',
    'SC',
    'SD',
    'TN',
    'TX',
    'UT',
    'VT',
    'WA',
    'WI',
    'WV',
    'WY',
  ],
  VEHICLE_AND_LOAN_STEPS: {
    VEHICLE_STEP: 'vehicle',
    LOAN_STEP: 'loan',
  },
  VEHICLE_CONSENT_TERMS: [
    'I am providing written instruction to Capital One, authorizing Capital One to obtain my open auto tradeline information from TransUnion for purposes of selecting which auto loan I am interested in refinancing.',
    'I authorize Capital One to share information I provide throughout the pre-qualification process with third parties for the purposes of obtaining my vehicle information from state DMV records and other vehicle-related records.',
  ],
  JOINT_VEHICLE_CONSENT_TERMS: [
    'We are providing written instruction to Capital One, authorizing Capital One to obtain my open auto tradeline information from TransUnion for purposes of selecting which auto loan I am interested in refinancing.',
    'We authorize Capital One to share information I provide throughout the pre-qualification process with third parties for the purposes of obtaining my vehicle information from state DMV records and other vehicle-related records.',
  ],
  UFO_CONSENT_LABEL:
    'I permit Capital One to get info from my credit report and state vehicle records so I can pick which vehicle and auto loan I want to refinance. This won’t impact my credit score.',
  COOKIE_KEYS: {
    refiId: 'C1_REFI_ID',
  },
  CHANGED_APPLICANT_KEYS: [
    'currentAddress.zipCode',
    'currentAddress.stateCode',
    'firstName',
    'lastName',
    'ssn',
  ],
  CHANGED_ADDRESS_KEYS: ['currentAddress.zipCode', 'currentAddress.stateCode'],
  PAGES: {
    VEHICLE_CONSENT: 'termsAndConditions',
    VEHICLE_LOAN: 'vehicleLoan',
  },
  EXIT_PAGE: {
    EXIT: 'exit',
  },
  VEHICLE_AND_LOAN_BASIC_PAGES: {
    CHOOSE_VEHICLE: 'vehicle',
    LOAN: 'loan',
    CONFIRM: 'confirm',
  },
  VEHICLE_AND_LOAN_MATCH_PAGE: {
    VEHICLE_LOAN: 'vehicleLoan',
  },
  INAPP_DECLINE_DELAY_PAGES: {
    DECLINE: 'ineligible',
  },
  PROGRESS_BAR_MICRO_STEPS: {
    macroStepName: 'Check eligibility',
    microStepsList: [
      'name',
      'communication',
      'identity',
      'address',
      'employment',
      'income',
      'coborrower',
      'co-app-communication',
      'co-app-identity',
      'co-app-address',
      'co-app-employment',
      'co-app-income',
      'termsAndConditions',
      'vehicleLoan',
      'vehicle',
      'loan',
      'review',
    ],
  },
  ICONIC_PROGRESS_BAR_MICRO_STEPS: {
    macroStepName: 'Check eligibility',
    microStepsList: [
      'name',
      'communication',
      'identity',
      'address',
      'employment',
      'income',
      'coborrower',
      'co-app-communication',
      'co-app-identity',
      'co-app-address',
      'co-app-employment',
      'co-app-income',
      'vehicleLoan',
      'vehicle',
      'loan',
      'confirm',
      'review',
    ],
  },
  UFO_PROGRESS_BAR_MICRO_STEPS: {
    macroStepName: 'Check eligibility',
    microStepsList: [
      'termsAndConditions',
      'vehicleLoan',
      'vehicle',
      'loan',
      'upfront-offers',
      'name',
      'communication',
      'identity',
      'address',
      'employment',
      'income',
      'coborrower',
      'co-app-communication',
      'co-app-identity',
      'co-app-address',
      'co-app-employment',
      'co-app-income',
      'review',
    ],
  },
  STEPS: () => Object.values(REFI_VEHICLE_LOAN_CONST.PAGES),
  STEPS_WITHOUT_MATCH: () => [
    REFI_VEHICLE_LOAN_CONST.PAGES.VEHICLE_CONSENT,
    REFI_VEHICLE_LOAN_CONST.PAGES.CHOOSE_VEHICLE,
    REFI_VEHICLE_LOAN_CONST.PAGES.LOAN,
  ],

  ICONIC_STEPS: (consent, match, exitFirst) => {
    let steps = [];
    if (exitFirst) {
      steps.push(REFI_VEHICLE_LOAN_CONST.EXIT_PAGE.EXIT);
    }

    steps = steps.concat(
      REFI_VEHICLE_LOAN_CONST.ICONIC_BASIC_STEPS(consent, match)
    );

    if (!exitFirst) {
      steps = steps.concat(REFI_VEHICLE_LOAN_CONST.EXIT_PAGE.EXIT);
    }
    return steps;
  },
  IN_APP_DECLINE_DELAY_STEPS: (consent, match) => {
    const steps = REFI_VEHICLE_LOAN_CONST.ICONIC_BASIC_STEPS(consent, match);
    steps.push(REFI_VEHICLE_LOAN_CONST.INAPP_DECLINE_DELAY_PAGES.DECLINE);

    return steps;
  },
  ICONIC_BASIC_STEPS: (consent, match) => {
    const steps = [];
    if (!consent) {
      steps.push(REFI_VEHICLE_LOAN_CONST.PAGES.VEHICLE_CONSENT);
    }
    if (match) {
      steps.push(REFI_VEHICLE_LOAN_CONST.PAGES.VEHICLE_LOAN);
    }
    steps.push(
      REFI_VEHICLE_LOAN_CONST.VEHICLE_AND_LOAN_BASIC_PAGES.CHOOSE_VEHICLE
    );
    steps.push(REFI_VEHICLE_LOAN_CONST.VEHICLE_AND_LOAN_BASIC_PAGES.LOAN);
    steps.push(REFI_VEHICLE_LOAN_CONST.VEHICLE_AND_LOAN_BASIC_PAGES.CONFIRM);

    return steps;
  },
  hostAppEventActionName: {
    initiateAnimationCompletion: 'initiate-animation-completion',
    initiateAnimationTransition: 'initiate-animation-transition',
  },
  HIGHLINE: {
    PRODUCT_ID: () =>
      REFI_VEHICLE_LOAN_CONST.isProdEnv()
        ? 'refi-prequalify-bff'
        : 'refi-prequalify-bff-np',
    URL_PREFIX: () => `${ENV_PATH}`,
  },
  SEARCH_TEXT: 'Looking Up Your Vehicle and Loan Information',
  LOADING_SEARCH_TEXT: 'Loading...',
  APPLICATION_TYPE: {
    INDIVIDUAL: 'INDIVIDUAL',
    JOINT: 'JOINT',
  },
  LIGHTHOUSE_QUERY_PARAM: {
    VEHICLE_CONSENT: {
      paramValue: 'lighthouse-consent',
      stepIndex: 0,
    },
    VEHICLE_AND_LOAN: {
      paramValue: 'lighthouse-vehicle-loan',
      stepIndex: 1,
    },
    VEHICLE: { paramValue: 'lighthouse-vehicle', stepIndex: 1 },
    LOAN: { paramValue: 'lighthouse-loan', stepIndex: 2 },
    VEHICLE_LOOKUP: { paramValue: 'lighthouse-vehicle-lookup', stepIndex: 1 },
    MANUAL_LOAN: { paramValue: 'lighthouse-manual-loan', stepIndex: 2 },
    ICONIC_EMPTY: { paramValue: 'lighthouse-iconic', stepIndex: 0 },
  },
  EXP_FEEDBACK_EVENT: (experimentName, feedback) =>
    new CustomEvent('host-app-event', {
      bubbles: true,
      composed: true,
      detail: {
        actionName: 'experiment-feedback',
        data: {
          experimentName,
          feedback,
        },
      },
    }),
  EXP_INIT_EVENT: (experimentName) =>
    this.EXP_FEEDBACK_EVENT(experimentName, { feedbackEvent: 'Initialized' }),
  EXP_SUCCESS_EVENT: (experimentName, rewardValue = 1) =>
    this.EXP_FEEDBACK_EVENT(experimentName, {
      feedbackEvent: 'Success',
      rewardValue,
    }),
  IN_APP_DECLINE_DELAY_TEST: 'in-app-decline-delay-test',
  ICONIC_V2: 'iconic-prequal-v2-only',
  ICONIC_INVISIBLE_PQ: 'iconic-invisible-pq-only',
  IN_APP_DECLINE_REASONS: {
    MOTORCYCLE: () => `We’re unable to refinance motorcycles.`,
    YEAR: (minYear) =>
      `We’re unable to refinance cars with a model year older than ${minYear}.`,
    MAKE: () => `We’re unable to refinance cars from this manufacturer.`,
    MODEL: () => `We’re unable to refinance cars of this model.`,
    AUTO_LEASE: () => `We don’t refinance cars that are currently under lease.`,
    CAPITAL_ONE_LOAN: () =>
      `We don’t refinance cars that are already financed by Capital One.`,
    INELIGIBLE_LENDER: () =>
      `We are unable to refinance loans from this lender.`,
    NO_WHOLESALE_VALUE: () =>
      `We’re unable to refinance this car because our system indicated that it does not have an established resale value.`,
    INELIGIBLE_TERMS: (minTerm, maxTerm) =>
      `We only refinance cars if your remaining loan term is between ${minTerm} and ${maxTerm} months.`,
    MONTHLY_PAYMENT: (maxMonthlyPayment) =>
      `We don’t refinance cars with a monthly loan payment greater than ${maxMonthlyPayment}.`,
    ATF: (minAmount, maxAmount) =>
      `We don’t refinance cars with a current loan balance less than ${minAmount} or greater than ${maxAmount}.`,
  },

  CAPITAL_ONE_LENDER_NAMES: [
    'CAPITAL ONE AUTO FIN',
    'CAPITAL ONE AUTO FINANCE',
    'CAPITAL ONE',
    'Capital One',
    'Captial One',
    'CapitalOne',
    'CaptialOne',
    'Cap1',
    'Cap One',
    'CapOne',
    'Cap 1',
    'Capitol One',
    'Captiol One',
    'CapitolOne',
    'CaptiolOne',
    'CAP ONE AUTO',
  ],
  INELIGIBLE_LENDER_NAMES: ['Harley David'],
  VAL_MATCH_TEST: 'val_match_test',
};
